import { useDispatch } from "react-redux";
import { GetOwnProfile } from "../api/services/profile";
import { useToast } from "./useToast";
import { setOwnProfile } from "../reducer/profileReducer";
import { AppDispatch } from "../app/store";

export function useOwnProfile() {
  const { showResponseMessages } = useToast();
  const dispatch = useDispatch<AppDispatch>();

  const getOwnProfile = async (query: any) => {
    try {
      const response = await GetOwnProfile(query);
      console.log("Raw profile response:", response);
      const { profile, status } = response;
      console.log("Extracted profile data:", profile);

      if (status === 200) {
        if (profile) {
          dispatch(setOwnProfile(profile));
          console.log("Profile loaded:", profile);
          console.log("Profile ID type:", typeof profile._id);
          console.log("Profile ID value:", profile._id);
        }
        return profile;
      } else {
        console.error("Failed to load profile:", response);
        showResponseMessages(500, "Failed to load profile", [
          "Profile data is missing",
        ]);
        return null;
      }
    } catch (error) {
      console.error("Failed to fetch profile:", error);
      showResponseMessages(500, "Failed to fetch profile", [
        "An error occurred while loading profile",
      ]);
      return null;
    }
  };

  return { getOwnProfile };
}
